import { Person } from '../types'

export const Persons: { [key: string]: Person } = {
  ney: {
    name: 'Neymar Jr',
    username: 'neymarjr',
    msg: 'Saudade do que a gente não viveu ainda!!',
    image: 'https://i.imgur.com/k2Uah9s.jpg'
  },
  negodi: {
    name: 'Nego Di',
    username: 'negodioficial',
    msg: 'Esse PR não vai subi ein negrão!!',
    image: 'https://i.imgur.com/dSXpg8A.png'
  },
  chaves: {
    name: 'Chaves',
    username: 'chaves',
    msg: 'Que burro dá zero no PR',
    image: 'https://i.imgur.com/sU81hQd.jpg'
  },
  professor: {
    name: 'Professor Raimundo',
    username: 'professor',
    msg: 'E o PR Ó',
    image: 'https://i.imgur.com/APOnHJN.jpg'
  },
  rossi: {
    name: 'Padre Marcelo Rossi',
    username: 'rossi',
    msg: 'Não diga a Deus o tamanho do seu PR.',
    image: 'https://i.imgur.com/z5gw1Wv.jpg'
  },
  yudi: {
    name: 'Yudi Tamashiro',
    username: 'yuditamashiro',
    msg: 'Melhor que esse PR só um pleisteixu 2',
    image: 'https://i.imgur.com/QKWi84I.jpg'
  },
  rod: {
    name: 'Ronaldinho Gaúcho',
    username: '10Ronaldinho',
    msg: 'Esse PR é aleatório d+ até pros meus padrões',
    image: 'https://i.imgur.com/D2YmPkl.jpg'
  },
  trump: {
    name: 'Donald J. Trump',
    username: 'realDonaldTrump',
    msg: "It's easier win the third world war than review this PR",
    image: 'https://i.imgur.com/UCtZwck.jpg'
  },
  jair: {
    name: 'Jair M. Bolsonaro',
    username: 'jairbolsonaro',
    msg: 'PR legal. Grande abraço 👍🏻',
    image: 'https://i.imgur.com/UrxtArM.jpg'
  },
  joelsantana: {
    name: 'Joel Santana',
    username: 'SantanaJoel',
    msg: 'Tu ta de brincation with me com esse PR, cara?',
    image: 'https://i.imgur.com/7Bj0A1A.jpg'
  },
  dilma: {
    name: 'Dilma Rousseff',
    username: 'dilmabr',
    msg: 'Nem se a gente estocar código, o PR não fica tão grande como esse',
    image: 'https://i.imgur.com/4R4AvNK.jpg'
  },
  marina: {
    name: 'Marina Silva',
    username: 'MarinaSilva',
    msg: 'Esse PR precisa ser mergeado. Democraticamente',
    image: 'https://i.imgur.com/L3FkANj.jpg'
  },
  stevie: {
    name: 'Stevie Wonder',
    username: 'StevieWonder',
    msg: "I can't see why did you do this changes!!",
    image: 'https://i.imgur.com/fc757Km.jpg'
  },
  vampeta: {
    name: 'Vampeta',
    username: 'vampeta',
    msg: 'Você finge que coda e eu finjo que aprovo',
    image: 'https://i.imgur.com/6F0yvRD.jpg'
  },
  faustao: {
    name: 'Faustão',
    username: 'faustao',
    msg: 'Esse PR ai é fera meu!',
    image: 'https://i.imgur.com/KScvaAy.jpg'
  },
  cirillo: {
    name: 'Marcus Cirillo',
    username: 'cirillo_oficial',
    msg: 'Mergeia esse PR, nem que vorte o cheque!!',
    image: 'https://i.imgur.com/CzOi3fI.jpg'
  },
  marilia: {
    name: 'Marília Gabriela',
    username: 'MGabrielaReal',
    msg: 'Poór que você fez isso?',
    image: 'https://i.imgur.com/bRPRe0T.jpg'
  },
  arnaldo: {
    name: 'Arnaldo Cezar Coelho',
    username: 'coelhoarnaldoc',
    msg: 'A regra é clara!',
    image: 'https://i.imgur.com/x4ZJO0Y.jpg'
  },
  jailson: {
    name: 'Jailson Mendes',
    username: 'JailsonMReal',
    msg: 'Ai que delícia de PR, cara!',
    image: 'https://i.imgur.com/FsMjQT0.jpg'
  },
  charlie: {
    name: 'Charlie Brown Jr',
    username: 'charliebrownjr',
    msg: 'O PR vai voltar... iêee 🎶',
    image: 'https://i.imgur.com/KZugqhH.png'
  },
  kid: {
    name: 'Kid Bengala',
    username: 'kidbengalala',
    msg: 'Que PRsão ein !!',
    image: 'https://i.imgur.com/98n10Mz.jpg'
  },
  bambam: {
    name: 'Kléber Bambam',
    username: 'bambamoficial',
    msg: 'O PR tá saindo da jaula p***a!!',
    image: 'https://i.imgur.com/jYMjLjU.jpg'
  },
  maike: {
    name: 'Maike da Swat',
    username: 'maikeswat',
    msg: 'Esse PR ta uma baguncinha',
    image: 'https://i.imgur.com/IcVwzsJ.jpg'
  },
  mano: {
    name: 'Mano Brown',
    username: 'manobrownof',
    msg: 'Esse PR ta pampa, irmão!',
    image: 'https://i.imgur.com/32HadJ1.png'
  },
  pedrobial: {
    name: 'Pedro Bial',
    username: 'PBiaL',
    msg: 'Dei uma espiadinha e gostei do que vi',
    image: 'https://i.imgur.com/N5x8C6H.jpg'
  },
  jacquin: {
    name: 'Erick Jacquin',
    username: 'erickJacquin',
    msg: 'Vocë é a vergonha da profession!',
    image: 'https://i.imgur.com/65WQ5nD.jpg'
  },
  zoio: {
    name: 'Everson Zoio',
    username: 'eversonZoio',
    msg: 'Sobe esse PR na marretaaaaaaa!!',
    image: 'https://i.imgur.com/m9f3J9u.jpg'
  },
  zeca: {
    name: 'Zeca Pagodinho',
    username: 'zecaPagodinho',
    msg: 'Descobri que contribuo demais!!',
    image: 'https://i.imgur.com/Qr4FC4g.jpg'
  },
  papaco: {
    name: 'Pistoleiro Papaco',
    username: 'papacoranger',
    msg: 'Pooraaaaa, tudo isso?!',
    image: 'https://i.imgur.com/jVYlqdZ.jpg'
  },
  gil: {
    name: 'Gil Brother',
    username: 'GilBrotherAway',
    msg: 'Num guenta deiz minuto de code review cumigo, morô?. Iai vaincará?',
    image: 'https://i.imgur.com/Vtw4TLp.jpg'
  },
  daciolo: {
    name: 'Deputado Cabo Daciolo',
    username: 'CaboDaciolo',
    msg: 'Glória a Deuxx!',
    image: 'https://i.imgur.com/rgc6e2A.jpg'
  },
  bilu: {
    name: 'ET Bilu',
    username: 'BiluOficial',
    msg: 'Busque conhecimento 🐚',
    image: 'https://i.imgur.com/HXauGHq.jpg'
  },
  portiolli: {
    name: 'Celso Portiolli',
    username: 'celsoportiolli',
    msg: 'E o pau TORANDO na timeline',
    image: 'https://i.imgur.com/W2cVcsK.jpg'
  },
  carluxo: {
    name: 'Carluxo',
    username: 'CarlosBolsonaro',
    msg:
      'Com a vitória no primeiro turno, vamos acabar com o PR e com as ISSUES. É a última vez que eles terão CODE REVIEW.',
    image: 'https://i.imgur.com/vOPLfoV.jpg'
  },
  davyjones: {
    name: 'Davy Jones',
    username: 'DavyJonesRJ',
    msg: 'Ae, seu PR é maneirão hein',
    image: 'https://i.imgur.com/2gyjYjP.jpg'
  },
  pecesiqueira: {
    name: 'PC Siqueira',
    username: 'PCSiqueira',
    msg: 'Mas poxa vida, que PR da hora!',
    image: 'https://i.imgur.com/Ywih160.jpg'
  },
  datena: {
    name: 'Datena',
    username: 'DatenaOficial',
    msg: 'Eu quero ibágens desse conflito!',
    image: 'https://i.imgur.com/w1y5zWB.jpg'
  },
  filipedeschamps: {
    name: 'Filipe Deschamps',
    username: 'FilipeDeschamps',
    msg: 'Esse PR ta FULL DOPAMINA!',
    image: 'https://i.imgur.com/hjz5kzN.png'
  },
  darthvader: {
    name: 'Darth Vader',
    username: 'DarthVader',
    msg: 'Sua falta de fé nesse PR é pertubadora.',
    image: 'https://i.imgur.com/LPLHgHX.jpg?1'
  },
  galvaobueno: {
    name: 'Galvão Bueno',
    username: 'GalvaoBueno',
    msg: 'Conflitoooooouuuuuuuu!!!!!!!.',
    image: 'https://i.imgur.com/8DiTArM.jpg?1'
  },
  dadodollabela: {
    name: 'Dado Dollabela',
    username: 'dadodolabeIla',
    msg: 'Tu traiu o movimento Clean Code, véio!',
    image: 'https://i.imgur.com/YsLeAi9.jpg'
  },
  bigsmoke: {
    name: 'Big Smoke',
    username: 'bigsmokegangsta',
    msg: 'All we had to do was follow the damn Review, CJ!',
    image: 'https://i.imgur.com/ZCqTesr.jpg'
  },
  xandao: {
    name: 'XANDAOGOD',
    username: 'xandaogod',
    msg: 'Relaxa que no fim do PR tem Xandão!',
    image: 'https://i.imgur.com/efshqAn.jpg'
  },
  julius: {
    name: 'Julius - Everybody Hates Chris',
    username: 'julius',
    msg: 'Esse PR me custou 25 linhas de código',
    image: 'https://i.imgur.com/xKPVD0w.jpg'
  },
  chewbacca: {
    name: 'Chewbacca',
    username: 'chewbacca',
    msg: 'hnnnhrrhhh awwgggghhh wrrhwrwwhw!',
    image: 'https://i.imgur.com/b8Xw46P.jpeg'
  },
  pabllovittar: {
    name: 'Pabllo Vittar',
    username: 'pabllovittar',
    msg: 'A previsao do tempo diz que seu PR fechoooou 🎶, YUKÊ',
    image: 'https://i.imgur.com/Rzj5M94.jpeg'
  },
  baroes: {
    name: 'Os Barões da Pisadinha',
    username: 'OsBaroesOfc',
    msg: 'Só basta você revisar aaa, que eu vou correndo mergear',
    image: 'https://i.imgur.com/4XwBkXI.jpg'
  }
}
